import { POSTHOG_SURVEY_PROGRAMS } from "@/lib/posthog/setup";

export type PostHogSurveyProgramKey = (typeof POSTHOG_SURVEY_PROGRAMS)[number]["key"];

export const POSTHOG_SURVEY_PROGRAM_KEYS = POSTHOG_SURVEY_PROGRAMS.map(
  (surveyProgram) => surveyProgram.key,
) as readonly PostHogSurveyProgramKey[];

export const POSTHOG_SURVEY_IDS = Object.freeze(
  Object.fromEntries(
    POSTHOG_SURVEY_PROGRAMS.flatMap((surveyProgram) => {
      const liveUrl = "liveUrl" in surveyProgram ? surveyProgram.liveUrl : undefined;
      const surveyId = liveUrl ? extractSurveyId(liveUrl) : undefined;

      return surveyId ? [[surveyProgram.key, surveyId]] : [];
    }),
  ),
) as Readonly<Partial<Record<PostHogSurveyProgramKey, string>>>;

const POSTHOG_SURVEY_PROGRAM_KEY_SET = new Set<string>(POSTHOG_SURVEY_PROGRAM_KEYS);

export function isPostHogSurveyProgramKey(value: string): value is PostHogSurveyProgramKey {
  return POSTHOG_SURVEY_PROGRAM_KEY_SET.has(value);
}

export function getPostHogSurveyProgram(key: PostHogSurveyProgramKey) {
  return POSTHOG_SURVEY_PROGRAMS.find((surveyProgram) => surveyProgram.key === key);
}

export function getPostHogSurveyId(key: PostHogSurveyProgramKey) {
  return POSTHOG_SURVEY_IDS[key];
}

function extractSurveyId(liveUrl: string) {
  try {
    return new URL(liveUrl).pathname.split("/surveys/")[1]?.split("/")[0] || undefined;
  } catch {
    return liveUrl.split("/surveys/")[1]?.split("/")[0] || undefined;
  }
}
